
import { useState, useEffect } from "react";

export function useLocalStorage<T>(key: string, initialValue: T): [T, (value: T) => void] {
  // État pour stocker notre valeur
  // Passer la fonction d'initialisation à useState pour que la logique ne s'exécute qu'une fois
  const [storedValue, setStoredValue] = useState<T>(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      // Récupérer de localStorage par clé
      const item = window.localStorage.getItem(key);
      // Analyser le JSON stocké ou retourner initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // En cas d'erreur, retourner initialValue
      console.log(error);
      return initialValue;
    }
  });

  // Retourner une fonction wrapper pour mettre à jour localStorage + state
  const setValue = (value: T) => {
    try {
      // Permettre à value d'être une fonction pour la même API que useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Sauvegarder state
      setStoredValue(valueToStore);
      // Sauvegarder dans localStorage
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      // Une erreur plus sophistiquée devrait être utilisée en production
      console.log(error);
    }
  };

  return [storedValue, setValue];
}
